import "./PasswordTextbox.css";

import { ReactComponent as PasswordHiddenIcon } from "shared/assets/Icons/eye.svg";
import { ReactComponent as PasswordVisibleIcon } from "shared/assets/Icons/eye-crossed-out.svg";
import { useState } from "react";
import { Input } from "../Input/Input";

export type PasswordTextboxProps = {
  name: string;
  placeholder: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  value?: string;
};

export const PasswordTextbox = ({
  onChange,
  onFocus,
  ...rest
}: PasswordTextboxProps) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  function togglePasswordVisibility() {
    setPasswordVisible(!passwordVisible);
    return null;
  }

  const PasswordVisibilityIcon = passwordVisible ? PasswordHiddenIcon : PasswordVisibleIcon;

  return (
    <>
      <div className="relative w-full">
        <Input icon={
          <PasswordVisibilityIcon
            aria-label={passwordVisible ? "Hide password button" : "Show password button"}
            onClick={() => togglePasswordVisibility()}
          />}
          type={passwordVisible ? "textbox" : "password"}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          {...rest} />
      </div>
    </>
  );
};
